/*
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-07-20 10:17:15
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-11 09:39:32
 * @FilePath: \mes-web\src\api\pm\groupApi.js
 * @Description: 项目分组
 */
import test from "@/utils/pmRequest";

export function getGroupListApi (params) {
  return test({
    url: "/pm/group/getAllGroup",
    method: "get",
    params
  });
}

export function updateGroupApi (data) {
  return test({
    url: "/pm/group/postGroup",
    method: "post",
    data
  });
}

export function deleteGroupApi (data) {
  return test({
    url: "/pm/group/deleteGroup",
    method: "post",
    data
  });
}

export function sortGroupApi (data) {
  return test({
    url: "/pm/group/sortGroup",
    method: "post",
    data
  });
}

export function joinGroupApi (data) {
  return test({
    url: "/pm/group/moveProject",
    method: "post",
    data
  });
}
